export default __webpack_public_path__ + "static/media/avatar.d280f83e.png";